import http from "../../core/services/http.service";

const ConditionReportRequestsService = {
  getConditionReportRequests(params = null) {
    return http.get(`/api/v1/inventories/condition-report-requests/`, {params});
  },
  updateConditionReportRequest(id, data, expand = '') {
    return http.put(`/api/v1/inventories/condition-report-requests/${id}/?expand=${expand}`, data);
  },
  updateConditionReportRequestPartially(id, data, expand = '') {
    return http.patch(`/api/v1/inventories/condition-report-requests/${id}/?expand=${expand}`, data);
  },
  removeConditionReportRequest(id) {
    return http.delete(`/api/v1/inventories/condition-report-requests/${id}/`);
  },
  createConditionReportRequest(data) {
    return http.post('/api/v1/inventories/create-condition-report-requests/', data)
  }

};

export default ConditionReportRequestsService;
